// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatMenuFixed__gEQ6 {
	position: fixed;
	right: 0;
	min-width: 160px;
	max-width: 160px;
	background-color: var(--f5-background);
	border: 1px solid var(--_16c0982e-background);
	border-radius: 8px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
	z-index: 99999999;
}
.chatMenu_K41m0 {
	position: absolute;
	left: 40px;
	top: 20px;
	min-width: 160px;
	max-width: 160px;
	background-color: var(--f5-background);
	border: 1px solid var(--_16c0982e-background);
	border-radius: 8px;
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
	z-index: 99999999;
}

.chatMenuUl_M82Tl {
	list-style: none;
	padding: 3px;
	margin: 0;
}

.chatMenuLi_ou_1L {
	padding: 8px;
	display: flex;
	align-items: center;
	color: var(--_16c098-background);
	font-size: 14px;
	cursor: pointer;
	border-radius: 4px;
	transition: background-color 0.2s ease;
}

.chatMenuLi_ou_1L:hover {
	background-color: var(--_16c0982e-background);
}

.chatMenuLi_ou_1L svg {
	margin-right: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/FixedContextMenu.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,QAAQ;CACR,gBAAgB;CAChB,gBAAgB;CAChB,sCAAsC;CACtC,6CAA6C;CAC7C,kBAAkB;CAClB,2CAA2C;CAC3C,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,gBAAgB;CAChB,sCAAsC;CACtC,6CAA6C;CAC7C,kBAAkB;CAClB,2CAA2C;CAC3C,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gCAAgC;CAChC,eAAe;CACf,eAAe;CACf,kBAAkB;CAClB,sCAAsC;AACvC;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":[".chatMenuFixed {\n\tposition: fixed;\n\tright: 0;\n\tmin-width: 160px;\n\tmax-width: 160px;\n\tbackground-color: var(--f5-background);\n\tborder: 1px solid var(--_16c0982e-background);\n\tborder-radius: 8px;\n\tbox-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n\tz-index: 99999999;\n}\n.chatMenu {\n\tposition: absolute;\n\tleft: 40px;\n\ttop: 20px;\n\tmin-width: 160px;\n\tmax-width: 160px;\n\tbackground-color: var(--f5-background);\n\tborder: 1px solid var(--_16c0982e-background);\n\tborder-radius: 8px;\n\tbox-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n\tz-index: 99999999;\n}\n\n.chatMenuUl {\n\tlist-style: none;\n\tpadding: 3px;\n\tmargin: 0;\n}\n\n.chatMenuLi {\n\tpadding: 8px;\n\tdisplay: flex;\n\talign-items: center;\n\tcolor: var(--_16c098-background);\n\tfont-size: 14px;\n\tcursor: pointer;\n\tborder-radius: 4px;\n\ttransition: background-color 0.2s ease;\n}\n\n.chatMenuLi:hover {\n\tbackground-color: var(--_16c0982e-background);\n}\n\n.chatMenuLi svg {\n\tmargin-right: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chatMenuFixed": `chatMenuFixed__gEQ6`,
	"chatMenu": `chatMenu_K41m0`,
	"chatMenuUl": `chatMenuUl_M82Tl`,
	"chatMenuLi": `chatMenuLi_ou_1L`
};
export default ___CSS_LOADER_EXPORT___;
